import { BaseCrossAnalysisUseCase } from './base-cross-analysis-use-case'
import { IQueryRepository } from '../repositories/i-query-repository'

export class BufferZonePressureUseCase extends BaseCrossAnalysisUseCase {
  readonly id = 'buffer-zone-pressure'
  readonly name = 'Zonas de Amortiguamiento y Presión Antrópica'

  constructor(queryRepo: IQueryRepository) {
    super(queryRepo)
  }
}
